/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PaginatedTrendAnalysisResultList,
  TrendAnalysisRequestRequest,
  TrendAnalysisResult,
  TrendAnalysisTaskResponse,
  TrendListParams,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자의 트렌드 분석 결과 목록을 조회합니다.
 * @summary 트렌드 분석 목록 조회
 */
export const trendList = (
  params?: TrendListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedTrendAnalysisResultList>(
    { url: `/api/ai-agent/trends/`, method: "GET", params, signal },
    options,
  );
};

export const getTrendListQueryKey = (params?: TrendListParams) => {
  return [`/api/ai-agent/trends/`, ...(params ? [params] : [])] as const;
};

export const getTrendListQueryOptions = <
  TData = Awaited<ReturnType<typeof trendList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrendListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendList>>> = ({
    signal,
  }) => trendList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof trendList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrendListQueryResult = NonNullable<
  Awaited<ReturnType<typeof trendList>>
>;
export type TrendListQueryError = ErrorType<unknown>;

export function useTrendList<
  TData = Awaited<ReturnType<typeof trendList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | TrendListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendList>>,
          TError,
          Awaited<ReturnType<typeof trendList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendList<
  TData = Awaited<ReturnType<typeof trendList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrendListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendList>>,
          TError,
          Awaited<ReturnType<typeof trendList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendList<
  TData = Awaited<ReturnType<typeof trendList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrendListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트렌드 분석 목록 조회
 */

export function useTrendList<
  TData = Awaited<ReturnType<typeof trendList>>,
  TError = ErrorType<unknown>,
>(
  params?: TrendListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrendListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 트렌드 분석 결과의 상세 정보를 조회합니다.
 * @summary 트렌드 분석 상세 조회
 */
export const trendRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrendAnalysisResult>(
    { url: `/api/ai-agent/trends/${id}/`, method: "GET", signal },
    options,
  );
};

export const getTrendRetrieveQueryKey = (id?: string) => {
  return [`/api/ai-agent/trends/${id}/`] as const;
};

export const getTrendRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof trendRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendRetrieve>>> = ({
    signal,
  }) => trendRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trendRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrendRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof trendRetrieve>>
>;
export type TrendRetrieveQueryError = ErrorType<unknown>;

export function useTrendRetrieve<
  TData = Awaited<ReturnType<typeof trendRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trendRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendRetrieve<
  TData = Awaited<ReturnType<typeof trendRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trendRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendRetrieve<
  TData = Awaited<ReturnType<typeof trendRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 트렌드 분석 상세 조회
 */

export function useTrendRetrieve<
  TData = Awaited<ReturnType<typeof trendRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrendRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * YouTube 음악 트렌드 분석을 시작합니다. 비동기로 실행됩니다.
 * @summary 새 트렌드 분석 시작
 */
export const trendAnalyze = (
  trendAnalysisRequestRequest: BodyType<TrendAnalysisRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrendAnalysisTaskResponse>(
    {
      url: `/api/ai-agent/trends/analyze/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trendAnalysisRequestRequest,
      signal,
    },
    options,
  );
};

export const getTrendAnalyzeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trendAnalyze>>,
    TError,
    { data: BodyType<TrendAnalysisRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trendAnalyze>>,
  TError,
  { data: BodyType<TrendAnalysisRequestRequest> },
  TContext
> => {
  const mutationKey = ["trendAnalyze"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trendAnalyze>>,
    { data: BodyType<TrendAnalysisRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return trendAnalyze(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrendAnalyzeMutationResult = NonNullable<
  Awaited<ReturnType<typeof trendAnalyze>>
>;
export type TrendAnalyzeMutationBody = BodyType<TrendAnalysisRequestRequest>;
export type TrendAnalyzeMutationError = ErrorType<unknown>;

/**
 * @summary 새 트렌드 분석 시작
 */
export const useTrendAnalyze = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trendAnalyze>>,
      TError,
      { data: BodyType<TrendAnalysisRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trendAnalyze>>,
  TError,
  { data: BodyType<TrendAnalysisRequestRequest> },
  TContext
> => {
  const mutationOptions = getTrendAnalyzeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 24시간 이내의 가장 최근 완료된 트렌드 분석 결과를 반환합니다.
 * @summary 최신 유효한 트렌드 분석 조회
 */
export const trendLatest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrendAnalysisResult>(
    { url: `/api/ai-agent/trends/latest/`, method: "GET", signal },
    options,
  );
};

export const getTrendLatestQueryKey = () => {
  return [`/api/ai-agent/trends/latest/`] as const;
};

export const getTrendLatestQueryOptions = <
  TData = Awaited<ReturnType<typeof trendLatest>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof trendLatest>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendLatestQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendLatest>>> = ({
    signal,
  }) => trendLatest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof trendLatest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrendLatestQueryResult = NonNullable<
  Awaited<ReturnType<typeof trendLatest>>
>;
export type TrendLatestQueryError = ErrorType<unknown>;

export function useTrendLatest<
  TData = Awaited<ReturnType<typeof trendLatest>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendLatest>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendLatest>>,
          TError,
          Awaited<ReturnType<typeof trendLatest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendLatest<
  TData = Awaited<ReturnType<typeof trendLatest>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendLatest>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trendLatest>>,
          TError,
          Awaited<ReturnType<typeof trendLatest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrendLatest<
  TData = Awaited<ReturnType<typeof trendLatest>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendLatest>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 최신 유효한 트렌드 분석 조회
 */

export function useTrendLatest<
  TData = Awaited<ReturnType<typeof trendLatest>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof trendLatest>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrendLatestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
